import dataStore from '../data/data-store';
import { IframeCreationRequest, IframeCreationResponse, IframeUrls } from '../models/models';

export class IframeService {
    public createPaymentIframe(request: IframeCreationRequest): IframeCreationResponse {
        const container = document.getElementById('card-container');
        if (!container) {
            return { success: false, errorMessage: 'expected div is not available' };
        }

        if (container.children.length > 0) {
            return { success: true, errorMessage: 'duplicate' };
        }

        dataStore.putData('ngpgHost', request.ngpgHost);

        const iframe = document.createElement('iframe');
        iframe.setAttribute('id', 'card-iframe');
        iframe.style.width = (request.styleProperties['width'] as string).replace('pct', '%');
        iframe.style.border = request.styleProperties['border'] as string;
        iframe.style.maxWidth = request.styleProperties['maxWidth'] as string;
        iframe.style.height = (request.styleProperties['height'] as string).replace('pct', '%');
        iframe.style.minHeight = request.styleProperties['minHeight'] as string;
        iframe.style.margin = request.styleProperties['margin'] as string;
        iframe.src = request.ngpgHost + IframeUrls[request.usecase];
        container.append(iframe);

        return { success: true, errorMessage: 'success' };
    }
}
